import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box } from '@material-ui/core'

import Icon1 from 'assets/images/features/1.png'
import Icon2 from 'assets/images/features/2.png'
import Icon3 from 'assets/images/features/3.png'
import Magics from 'assets/images/features/exclusive.png'
import StaticSnow1 from 'assets/images/features/static1.png'
import useWindowDimensions from 'hooks/useDimensions'
import Snowfall from 'react-snowfall'

interface Props {
    mainRef: any
}

const Features: React.FC<Props> = ({ mainRef }) => {
    const screenWidth = useWindowDimensions().width
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        screenWidth > 767 ? setIsMobile(false) : setIsMobile(true)
    }, [screenWidth])
    return (
        <StyledContainer>
            <Snowfall color='white' snowflakeCount={500} />
            <img src={StaticSnow1} alt='' />
            <Title {...{ ref: mainRef }}>Features</Title>
            <Box>
                <FeatureItem>
                    <img src={Icon1} alt='' />
                    <Box mt='6px'>Invest</Box>
                    <Box>Let your Crypto work hard for you!</Box>
                    <Box>
                        OLAF holders can stake the tokens into the Staking Pools to receive rewards and transaction fees. Staking indirectly serves to support the system.
                    </Box>
                </FeatureItem>
                <FeatureItem>
                    <img src={Icon2} alt='' />
                    <Box mt='6px'>Build</Box>
                    <Box>Easy & Fast on-chain API creation!</Box>
                    <Box>
                        Frozen Exchange protocol is a staple of the DeFi infrastructure, an original financial permissionless development platform, offering a flexible and versatile vAMM, providing developers with great flexibility and customizability.
                    </Box>
                </FeatureItem>
                <FeatureItem>
                    <img src={Icon3} alt='' />
                    <Box mt='6px'>Trade</Box>
                    <Box>Take your trading to the next level!</Box>
                    <Box>
                        Trade on-chain derivatives with High Leverage, Low Fees, Low Slippage and Gas Costs. Frozen Exchange enables efficient trading at the best available price. Easily exchange ERC-20 tokens permissionless.
                    </Box>
                </FeatureItem>
            </Box>
            <ExclusiveBox>
                <img src={Magics} alt='' />
                <Box display='flex' flexDirection='column' position='absolute' width='fit-content'>
                    <Text1>Exclusive pre-sale</Text1>
                    <Text2>start soon!</Text2>
                </Box>
            </ExclusiveBox>
            {isMobile && <OlafText>3D Model NFTs will <span>coming soon</span>!</OlafText>}
        </StyledContainer>
    )
}

const OlafText = styled(Box)`
    @media (max-width: 767px) {
        padding-left: 33px;
        padding-right: 28px;
    }
    @media (max-width: 360px) {
        padding-left: 17px;
        padding-right: 14px;
    }
    margin-top: 200px;
    font-weight: bold;
    font-size: 36px;
    line-height: 42px;
    color: #3F78BD;
    text-align: center;
    span {
        font-weight: bold;
        font-size: 36px;
        line-height: 42px;
        color: #f6669e;
    }
`

const Text2 = styled(Box)`
    font-weight: bold;
    font-size: 64px;
    line-height: 80px;
    @media (max-width: 767px) {
        font-size: 36px;
        line-height: 42px;
    }
    text-align: center;
    letter-spacing: -2px;
    text-transform: uppercase;
    color: white;
    text-shadow: 0px 4px 20px rgba(11, 24, 69, 0.71);
`

const Text1 = styled(Box)`
    font-weight: bold;
    font-size: 64px;
    line-height: 80px;
    @media (max-width: 767px) {
        font-size: 36px;
        line-height: 42px;
    }
    text-align: center;
    letter-spacing: -2px;
    text-transform: uppercase;
    color: #FFD80D;
    text-shadow: 0px 4px 20px rgba(11, 24, 69, 0.71);
`

const ExclusiveBox = styled(Box)`
    position: relative;
    margin-top: 123px;
    display: flex;
    justify-content: center;
    /* overflow: hidden; */
    @media (max-width: 767px) {
        margin-top: 59px;
    }
    >img {
        @media (max-width: 767px) {
            height:412.07px;
        }
    }
    >div {
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        
        @media (max-width: 767px) {
            top: 77%;
        }
    }
`
const FeatureItem = styled(Box)`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    >div:first-of-type {
        font-weight: 600;
        font-size: 36px;
        line-height: 54px;
        text-align: center;
        color: #FB6EA4;
    }
    >div:nth-of-type(2) {
        margin-top: 21px;
        font-weight: 600;
        font-size: 24px;
        line-height: 24px;
        text-align: center;
        color: #343434;
        max-width: 285px;
    }
    >div:nth-of-type(3) {
        margin-top: 24px;
        font-weight: 500;
        font-size: 18px;
        line-height: 23.4px;
        text-align: center;
        color: #343434;
        max-width: 285px;
    }   
`

const Title = styled(Box)`
    text-align: center;
    font-weight: 900;
    font-size: 48px;
    line-height: 109%;
    @media (max-width: 767px) {
        font-size: 36px;
        line-height: 109%;
    }
    color: #3F78BD;
`

const StyledContainer = styled(Box)`
    background-image: linear-gradient(90deg, #c0daee 0%, #fdfeff 50%, #c0daee 100%);
    padding-top: 89px;
    padding-bottom: 24px;
    @media (max-width: 767px) {
        padding-top: 71px;
        padding-bottom: 29px;
    }
    position: relative;
    overflow: hidden;
    >img:first-of-type {
        position: absolute;
        top: 14%;
        left: 51px;
        right: 47.96px;
        height: auto;
        @media (max-width: 360px) {
            display: none;
        }
    }
    >div:nth-of-type(2) {
        margin-top: 67.38px;
        display: flex;
        justify-content: center;
        >div+div {
            margin-left: 77px;
            margin-top: 0;
        }
        @media (max-width: 767px) {            
            margin-top: 46px;
            flex-direction: column;
            >div+div {
                margin-top: 88px;
                margin-left: 0;
            }
        }
    }
    >canvas {
        top: auto !important;
        bottom: 0 !important;
        height: 50% !important;
    }
`

export default Features